/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sample
 */
export interface Sample {
    /**
     * 
     * @type {number}
     * @memberof Sample
     */
    value: number;
    /**
     * 
     * @type {Date}
     * @memberof Sample
     */
    timestamp: Date;
}

/**
 * Check if a given object implements the Sample interface.
 */
export function instanceOfSample(value: object): value is Sample {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function SampleFromJSON(json: any): Sample {
    return SampleFromJSONTyped(json, false);
}

export function SampleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sample {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'timestamp': (new Date(json['timestamp'])),
    };
}

export function SampleToJSON(json: any): Sample {
    return SampleToJSONTyped(json, false);
}

export function SampleToJSONTyped(value?: Sample | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'timestamp': ((value['timestamp']).toISOString()),
    };
}

